import { render, staticRenderFns } from "./OriginalAboutInfo.vue?vue&type=template&id=dc64fdae"
import script from "./OriginalAboutInfo.vue?vue&type=script&lang=js"
export * from "./OriginalAboutInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports